export function exportCsv(rows, filename) {
  if (!rows.length) throw new Error('No hay registros para exportar.');
  const columns = [...new Set(rows.flatMap(row => Object.keys(row)))];
  const cell = value => {
    let text = String(value ?? '');
    if (/^[=+@-]/.test(text)) text = "'" + text;
    return '"' + text.replace(/"/g, '""') + '"';
  };
  const text = '\uFEFF' + [columns, ...rows.map(row => columns.map(key => row[key]))].map(row => row.map(cell).join(';')).join('\r\n');
  const url = URL.createObjectURL(new Blob([text], { type: 'text/csv;charset=utf-8' }));
  const link = document.createElement('a'); link.href = url; link.download = filename; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export async function exportXlsx(rows, filename, sheetName = 'Datos') {
  if (!rows.length) throw new Error('No hay registros para exportar.');
  const { default: ExcelJS } = await import('exceljs');
  const workbook = new ExcelJS.Workbook(); const sheet = workbook.addWorksheet(sheetName);
  const columns = [...new Set(rows.flatMap(row => Object.keys(row)))];
  sheet.columns = columns.map(key => ({ header: key, key, width: 24 }));
  rows.forEach(row => sheet.addRow(Object.fromEntries(columns.map(key => [key, typeof row[key] === 'object' && row[key] !== null ? JSON.stringify(row[key]) : row[key] ?? '']))));
  sheet.getRow(1).font = { bold: true }; sheet.views = [{ state: 'frozen', ySplit: 1 }];
  sheet.autoFilter = { from: { row: 1, column: 1 }, to: { row: sheet.rowCount, column: columns.length } };
  const url = URL.createObjectURL(new Blob([await workbook.xlsx.writeBuffer()], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
  const link = document.createElement('a'); link.href = url; link.download = filename; link.click(); setTimeout(() => URL.revokeObjectURL(url), 1000);
}
